export const SET_RECOMMENDED_PRODUCTS = "recommended product: SET";

export function setRecommendedProductsAction(products) {
  return {
    type: SET_RECOMMENDED_PRODUCTS,
    payload: products,
  };
}
